import { useState, useEffect, useCallback } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Panel, Slider, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

const markLinkStyle = {
  fontSize: 10,
  fontWeight: 500,
  padding: '2px',
};

export const DisplayORPPhSliderItem = ({ register, tc, icon, min, max, step, onChange, disabled, ispH, borderOff }) => {
  const displayPh = ispH;

  const convertToSliderValue = useCallback(
    (theValue) => {
      if (!Number.isFinite(theValue)) {
        return min;
      }
      let theSetValue = theValue;
      if (displayPh) {
        theSetValue = theValue / 10;
      } else {
        theSetValue = theValue * 10;
      }
      return theSetValue;
    },
    [displayPh, min],
  );

  const [value, setValue] = useState(() => convertToSliderValue(register.value));
  // const formatValue = (value) => {
  //   if (onFormat !== undefined) {
  //     return onFormat(value, "");
  //   } else {
  //     return value;
  //   }
  // };

  const forMatValue = () => {
    return value;
  };

  const convertFromSliderValue = (sValue) => {
    let theSetValue = sValue;

    if (displayPh) {
      theSetValue = sValue * 10;
    } else {
      theSetValue = sValue / 10;
    }
    devLog('converted from slider =', sValue, theSetValue, displayPh);
    return theSetValue;
  };

  const updateValue = (value, event) => {
    const convertedValue = convertFromSliderValue(value);
    devLog('converted from slider =', convertedValue, event, value);
    onChange(register, convertedValue);
  };

  useEffect(() => {
    const convertedValue = convertToSliderValue(register.value);
    setValue(convertedValue);
    devLog('temperature value updated to :', convertedValue);
  }, [register.value, convertToSliderValue]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div className="truncate space-y-1 w-1/2">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>
        </div>
        <div
          style={{
            display: 'block',
            width: '100%',
            paddingLeft: 10,
            paddingRight: 5,
          }}
        >
          <Slider
            progress
            barClassName="slideritem"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={setValue}
            onChangeCommitted={updateValue}
            renderTooltip={forMatValue}
            disabled={disabled}
            graduated
            renderMark={(mark) => {
              if (displayPh) {
                if ([7.0, 7.2, 7.4, 7.6, 7.8, 8].includes(mark)) {
                  return <span style={markLinkStyle}>{mark}</span>;
                }
              } else {
                if (mark % 20 === 0) {
                  return <span style={markLinkStyle}>{mark}</span>;
                }
              }
              return null;
            }}
          />
        </div>
      </Flex>
    </Panel>
  );
};
